import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CompareProvider } from "@/context/CompareContext";
import { Layout, RequireAuth } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Listings from "@/pages/Listings";
import ListingDetail from "@/pages/ListingDetail";
import ListingForm from "@/pages/ListingForm";
import MyListings from "@/pages/MyListings";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import Compare from "@/pages/Compare";
import Builder from "@/pages/Builder";
import Seller from "@/pages/Seller";
import Settings from "@/pages/Settings";
import Legal from "@/pages/Legal";
import Admin from "@/pages/admin/Admin";
import { Login, Register, VerifyEmail, Forgot, Unlock, GoogleCallback, CompleteProfile } from "@/pages/auth";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CompareProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/ilanlar" element={<Listings />} />
              <Route path="/ilan/:id" element={<ListingDetail />} />
              <Route path="/ilan-ver" element={<RequireAuth><ListingForm /></RequireAuth>} />
              <Route path="/ilan/:id/duzenle" element={<RequireAuth><ListingForm /></RequireAuth>} />
              <Route path="/ilanlarim" element={<RequireAuth><MyListings /></RequireAuth>} />
              <Route path="/katalog" element={<Catalog />} />
              <Route path="/katalog/:id" element={<ProductDetail />} />
              <Route path="/karsilastir" element={<Compare />} />
              <Route path="/drone-topla" element={<Builder />} />
              <Route path="/satici/:id" element={<Seller />} />
              <Route path="/ayarlar" element={<RequireAuth><Settings /></RequireAuth>} />
              <Route path="/yonetim" element={<RequireAuth admin><Admin /></RequireAuth>} />
              <Route path="/yasal/:doc" element={<Legal />} />
              <Route path="/giris" element={<Login />} />
              <Route path="/kayit" element={<Register />} />
              <Route path="/dogrula" element={<VerifyEmail />} />
              <Route path="/sifremi-unuttum" element={<Forgot />} />
              <Route path="/hesap-kilidi" element={<Unlock />} />
              <Route path="/auth/google" element={<GoogleCallback />} />
              <Route path="/profil-tamamla" element={<CompleteProfile />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          <Toaster richColors position="bottom-right" theme="light" />
        </CompareProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
